import React from 'react';
import PropTypes from 'prop-types';
import AuthContext from "flexbiz-core/components/auth/Context";
import BottomNavigationDefault from './BottomNavigationDefault';
import BottomNavigationAgent from './BottomNavigationAgent';
import BottomNavigationThuMua from './BottomNavigationThuMua';
import BottomNavigationMidomax from './BottomNavigationMidomax';
import BottomNavigationBDS from './BottomNavigationBDS';
import { useMediaQuery } from '@mui/material';

function ButtonNavi({defaultValue,history,code,style}){
  const context = React.useContext(AuthContext);
  const isMobile = useMediaQuery('(max-width:540px)');
  if(!context.appInfo) return null;
  if(context.appInfo.app_code=="MIDOMAX"){
    return <BottomNavigationMidomax defaultValue={defaultValue} history={history} code ={code} style={style}/>
  }else{
    if(context.queryParams.for_agent==8){
      return <BottomNavigationBDS defaultValue={defaultValue} history={history} code ={code} style={style}/>
    }else if(context.queryParams.for_agent==2){
      return <BottomNavigationThuMua defaultValue={defaultValue} history={history} code ={code} style={style}/>
    } else if(context.queryParams.for_agent==1){
      return <BottomNavigationAgent defaultValue={defaultValue} history={history} code ={code} style={style}/>
    }else if(isMobile){
      return <BottomNavigationDefault defaultValue={defaultValue} history={history} code ={code} style={style}/>
    }else{
      return null;
    }
  }
}
ButtonNavi.propTypes={
  mediaQueryMatches: PropTypes.bool,
  history:PropTypes.any,
  match:PropTypes.any,
  defaultValue:PropTypes.number,
  code:PropTypes.any,
  style:PropTypes.any
}
export default  ButtonNavi;
